var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodingGameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 2083 2083",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2083v2083H0z",
    fill: "#fcd207"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1f2528"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1636c411.554-97.771 692.897-283.177 724-637 10.714-131.212 67.364-243.777 216-319 207.675-80.617 305.728-52.164 390-10 92.668 81.722 119.468 199.94 50 371.5-31.914 100.266-291.001 223.867-410 258.5-392.539 175.893-595.504 430.282-561 783H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1666.5,
    cy: 408,
    rx: 196.5,
    ry: 192
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingGameLogo);
export default __webpack_public_path__ + "static/media/coding-game-logo.2afdb10fe623c6624f6fbe7aa918a216.svg";
export { ForwardRef as ReactComponent };